$(function () {
    var state = false;
    var filterState = false;
    var innerHeight = window.innerHeight;
    var headerHeight = 87;
    var buttonHeight = 60;
    var footerHeight = 55;
    var filterHeight = headerHeight + buttonHeight + footerHeight;
    var pos;

    /**
     * ハンバーガーメニューを開いた際のトグル処理
     */
    function hamburgerSwitchOn() {
        $("body").addClass("is-fixed").css({ top: -pos });
        $(".l-header-sp").addClass("is-fixed");
        $(".slidedown").removeClass("show").addClass("hide");
        $(".slide-filter").removeClass("show").addClass("hide");
        $(".modal-menu").css("height", innerHeight + "px");
        $(".slidedown-brand").text("条件を変更する");
    }
    /**
     * ハンバーガーメニューを閉じた際のトグル処理
     */
    function hamburgerSwitchOff() {
        $("body").removeClass("is-fixed").css({ top: 0 });
        $(".l-header-sp").removeClass("is-fixed");
        $(".slidedown").removeClass("show").addClass("hide");
    }

    /**
     * フィルターメニューを開いた際のトグル処理
     */
    function filterSwitchOn() {
        $("body").addClass("is-fixed").css({ top: -pos });
        $(".slidedown").removeClass("hide").addClass("show");
        $(".slide-filter")
            .removeClass("hide")
            .addClass("show")
            .css("height", innerHeight - filterHeight + "px");
        $(".slidedown-brand").text("閉じる");
    }
    /**
     * フィルターメニューを閉じた際のトグル処理
     */
    function filterSwitchOff() {
        $("body").removeClass("is-fixed").css({ top: 0 });
        $(".slide-filter").removeClass("show").addClass("hide");
        $(".slidedown-brand").text("条件を変更する");
    }

    $(".hamburger-menu").click(function () {
        if (state == false || filterState == true) {
            pos = $(window).scrollTop();
            hamburgerSwitchOn();
            state = true;
            filterState = false;
        } else {
            hamburgerSwitchOff();
            window.scrollTo({
                top: pos,
                left: 0,
                behavior: "instant",
            });
            state = false;
        }
    });

    $(".slidedown-brand").click(function () {
        if (filterState == false) {
            pos = $(window).scrollTop();
            filterSwitchOn();
            filterState = true;
        } else {
            filterSwitchOff();
            window.scrollTo({
                top: pos,
                left: 0,
                behavior: "instant",
            });
            filterState = false;
        }
    });

    $(window).on("scroll", scrollHandler);

    function scrollHandler() {
        var slidedownBtn = $(".slidedown");
        var scroll = window.pageYOffset;
        if (filterState == false) {
            if (scroll > 1000) {
                slidedownBtn.removeClass("hide").addClass("show");
            } else {
                slidedownBtn.removeClass("show").addClass("hide");
            }
        }
    }
});
